module.exports = __webpack_public_path__ + "img/me.16d914a3.jpg";